import { render, staticRenderFns } from "./StickyMillageHeader.vue?vue&type=template&id=2c985ed5&"
import script from "./StickyMillageHeader.vue?vue&type=script&lang=js&"
export * from "./StickyMillageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports